/* Lazy-loads Amazon star ratings: the <amazon-product-rating> element is only created
   when its placeholder (.snz-amazon-rating) is within 400px of the viewport. */
(function () {
  if (window.__snzAmazonLazy) return;
  window.__snzAmazonLazy = true;

  function mount(el) {
    if (el.getAttribute('data-snz-done')) return;
    el.setAttribute('data-snz-done', '1');
    var w = document.createElement('amazon-product-rating');
    w.setAttribute('product-sku', el.getAttribute('data-snz-sku'));
    w.setAttribute('product-external-id', 'gid://shopify/ProductVariant/' + el.getAttribute('data-snz-vid'));
    w.style.pointerEvents = 'none';
    w.style.cursor = 'default';
    el.appendChild(w);
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); mount(e.target); }
      });
    }, { rootMargin: '400px 0px' });
  }

  function scan() {
    var list = document.querySelectorAll('.snz-amazon-rating:not([data-snz-seen])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-snz-seen', '1');
      if (io) { io.observe(list[i]); } else { mount(list[i]); }
    }
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  // catches cards added later by infinite scroll / filtering
  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
})();
